import { getUrl } from 'helpers';

export default function Image({ alt, className, path, src, title }: ImageProps) {

    const imgSrc = getUrl(src || `/assets/images/${path}`);

    return <picture>
        <img className={className} alt={alt} src={imgSrc} title={title} />
    </picture>;

}